<app-loader *ngIf="isLoading"></app-loader>
<div class="relative pt-2">
  <div class="mx-auto w-100 relative">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <app-main-heading>
          <span class="" title>{{
            "MANAGEDEVICE.NEWSCORE"| translate
            }}</span>
        </app-main-heading>
      </div>
    </div>
  </div>
</div>

<div class="bg-white text-center rounded-25 relative" *ngIf="deviceId?.length === 0">
  <img src="assets/images/score-management.png" width='100%' alt="" style="opacity: 0.3;">
  <div class="tapToAddDevice" style="top: 30%;">
    <img src="assets/images/NODeviceLock.png" alt="">
    <p class="mt-2">{{ "DASHBOARD.TAPTOADD" | translate }}</p>
    <button class="bg-orgclr text-sm submit-btn buynow" (click)="addDevice()">
      {{"ADDDEVICE.ADDDEVICE" | translate }}
    </button>
  </div>
</div>

<div class="relative pt-2 pb-6" *ngIf="deviceId?.length != 0">
  <div class="mx-auto d-none d-lg-block w-100 relative">
    <!-- verticle  -->
    <div class="d-flex mt-3 mb-5">
      <div class="">
        <nav id="sidebar">
          <!-- <div
            class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
            <ul class="flex-column min-w-100 d-flex list-unstyled me-4 faq-pills" id="pills-tabVertical">
              <li *ngFor="let user of userResponse; let i = index" (click)="getScoreManagement(user,i)"
                [ngClass]="selectedIndex == i ? '' : ''"
                class="align-items-centerq-vertical-text-user cursor-pointer me-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="me-2 rounded-imgess">
                    <span style="height: 50px; width: 50px ">
                      <img style="height: 40px; width: 40px" src="./assets/images/Group 1000007040score user.png"
                        *ngIf=" user?.roleTypeStr== 'Super Admin' " />
                      <img style="height: 40px; width: 40px" src="./assets/images/Vector 1scoreadminuser.png"
                        *ngIf=" user?.roleTypeStr== '!Super Admin' " />
                    </span>
                  </div>





                  <div class="text-sm q-tab-title-score me-4" data-toggle="tooltip" title="{{user?.name }}">
                    {{
                    user?.name == null
                    ? "N/A"
                    : user?.name
                    }}
                    <span class=" ms-3 badge badge-pill status-text-new">{{
                      user?.roleTypeStr}}</span>
                    <div class="font-weight-700 text-ellipse mb-4">
                      <span>{{"MANAGEUSER.DEVICES" | translate}}: </span>
                      <span>{{ user?.deviceCount }} </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div> -->


          <div
            class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
            <ul class="flex-column min-w-100 d-flex list-unstyled me-4" id="pills-tabVertical">
              <li *ngFor="
              let user of userResponse;
                let i = index;
               
              " (click)="getScoreManagement(user,i)" [ngClass]="
                selectedIndex == i ? 'q-vertical-text-user-selected':'q-vertical-text-user' "
                class="align-items-center cursor-pointer bg-white">
                <tab-title>
                  <span title1><img *ngIf="user.roleTypeStr == 'Super Admin'" src="./assets/images/crownicon.png" alt=""
                      class="" style="width: 35px;height: 35px;" /></span>
                  <span title1><img *ngIf="user.roleTypeStr != 'Super Admin'" src="./assets/images/UserBlueBag.svg"
                      alt="" class="" style="width: 35px;height: 35px;" /></span>
                  <span title3 data-toggle="tooltip" style="font-size: 16px;" title="{{user?.name}}">
                    {{ user?.name == null ? "" : user?.name.length > 18 ? user?.name.slice(0,18) + "..." :
                    user?.name }}
                  </span>
                  <span title4 data-toggle="tooltip" style="font-size: 14px; font-weight: 600;"
                    title="{{user?.deviceCount}}">
                    <span>{{ "SCOREMANAGEMENT.DEVICESSTR" | translate}}</span>
                    {{
                    user?.deviceCount == null ? "" : user?.deviceCount
                    }}</span>
                </tab-title>
              </li>
            </ul>
          </div>

        </nav>
      </div>
      <div class="p-4 q-vertical-content" [ngClass]="
              selectedIndex === 0
                ? 'border-radius'
                : 'border-radius'
            ">
        <div class="container-fluid">
          <span class="font-weight-600" *ngIf="ScoreManagementData?.length != 0" [title]="myuserName">
            {{myuserName}}
            {{"MANAGEUSER.DEVICES" | translate}}</span>
          <div class="d-flex flex-wrap mb-5">
            <ng-container *ngIf="ScoreManagementData?.length === 0">
              <div class="col-md-12 text-center">
                <div class="nodatafounddiv">
                  <img src=" assets/images/NoRecordFound.png" class="img-fluid" alt="" />
                  <h1 class="mt-4">
                    <app-main-heading>
                      <span title>{{
                        "MANAGEDEVICE.NODATAFOUND" | translate
                        }}</span>
                    </app-main-heading>
                  </h1>
                </div>
              </div>
            </ng-container>
            <div class="cursor-pointer m-2" (click)="securityById(item.deviceOrSystemId)"
              *ngFor="let item of ScoreManagementData;let i = index">
              <div class="q-sm-card p-3 me-3 mt-2">
                <div class="d-flex align-items-center flex-row flex-nowrap mb-1">
                  <div class="me-2">
                    <span *ngIf="item?.deviceType == 'SYSTEM'">
                      <img src="../../../assets/images/systemRounded.svg" alt="" class="mx-auto" />
                    </span>
                    <span *ngIf="item?.deviceType == 'MOBILE'">
                      <img src="../../../assets/images/Group 1000007040scorephone.png" alt="" class="mx-auto" />
                    </span>
                  </div>
                  <div class="mb-2 ms-2">
                    <div class="font-weight-700 mt-2" [title]="item?.name">
                      {{ item?.name == null ? "" : item?.name.length > 15 ? item?.name.slice(0,15) + "..." :
                      item?.name }}
                      <span class="badge badge-pill status-text-recommendation justify-content-center my-1 ms-2 "
                        *ngIf="item?.sumOfAllRecommendations!=0">
                        {{item?.sumOfAllRecommendations}} {{ "DASHBOARD.RECOMMENDATIONS"|translate}}</span>
                      <span class="q-form-white-submits text-xs ms-5" style="position:absolute;right: 24px;top: 29px;"
                        (click)="securityById(item.deviceOrSystemId)">
                        <img style="width: 15px;height: 15px;" alt="" src="../../../assets/images/scoreArrow.svg"
                          width="26" height="26" />
                      </span>
                    </div>
                    <!-- <div class="d-flex align-items-center justify-content-center my-1"> -->

                    <!-- </div> -->
                    <div class="text-xs-date font-weight-500" *ngIf="item.lastSyncDate != null"
                      [ngStyle]="{'white-space': selectedLanguage === 'it' ? 'nowrap' : 'unset'}">
                      {{"MANAGEDEVICE.LASTSYNCON"|translate}} {{item.lastSyncDate}}
                    </div>
                    <div class="text-xs-date font-weight-500" *ngIf="item.lastSyncDate == null"
                      [ngStyle]="{'white-space': selectedLanguage === 'it' ? 'nowrap' : 'unset'}">
                      {{"MANAGEDEVICE.SCORE_NOT_SYNC"|translate}}
                    </div>
                  </div>

                </div>
                <div class="d-flex mt-4" [ngClass]="selectedLanguage === 'it' ? 'ms-0' : 'ms-5'">
                  <div class="q-tab-title-score" style="width: 33px;height: 33px;">
                    <img *ngIf="item.securityScore > 500 && item.securityScore < 801" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/goodScoreDonut.png">
                    <img *ngIf="item.securityScore > -1 && item.securityScore < 251" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/lowScoreDonut.svg">
                    <img *ngIf="item.securityScore > 250 && item.securityScore < 501" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/mediumScoreDonuts.png">
                    <img *ngIf="item.securityScore > 800 && item.securityScore < 1001" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/excellentDonuts.svg">
                  </div>
                  <div>
                    <span class="mt-1" [ngClass]="selectedLanguage === 'it' ? 'ms-1' : 'ms-3'"
                      [ngStyle]="{'white-space': selectedLanguage === 'it' ? 'nowrap' : 'unset'}">{{
                      "MANAGEUSER.SECURITY"
                      | translate }}</span>
                    <div style="min-width: 91px;" [ngClass]="selectedLanguage === 'it' ? 'ms-1' : 'ms-3'">
                      <span class="scores" [style.color]="getColor(item.securityScore)">{{item.securityScore}}</span>
                      <span class="scoretype"> {{ "SCOREMANAGEMENT.OFSTR" | translate}}
                        {{item.securityTotalScore}}</span>
                    </div>
                  </div>
                  <div class="q-tab-title-score ms-4" style="width: 33px;height: 33px;">
                    <img *ngIf="item.privacyScore > 500 && item.privacyScore < 801" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/goodScoreDonut.png">
                    <img *ngIf="item.privacyScore > -1 && item.privacyScore < 251" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/lowScoreDonut.svg">
                    <img *ngIf="item.privacyScore > 250 && item.privacyScore < 501" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/mediumScoreDonuts.png">
                    <img *ngIf="item.privacyScore > 800 && item.privacyScore < 1001" style="width: 33px;height: 33px;"
                      alt="" src="assets/images/excellentDonuts.svg">
                  </div>
                  <div>
                    <span class="mt-1" [ngClass]="selectedLanguage === 'it' ? 'ms-1' : 'ms-3'"
                      [ngStyle]="{'white-space': selectedLanguage === 'it' ? 'nowrap' : 'unset'}">{{
                      "MANAGEUSER.PRIVACY" | translate }}</span>
                    <div [ngClass]="selectedLanguage === 'it' ? 'ms-1' : 'ms-3'" style="min-width: 91px;">
                      <span class="scores" [style.color]="getColor(item.privacyScore)">{{item.privacyScore}}</span>
                      <span class="scoretype"> {{"SCOREMANAGEMENT.OFSTR" | translate }}
                        {{item.privacyTotalScore}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="d-block d-lg-none">
    <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample">
      <div *ngFor="
          let user of userResponse;
          let i = index
        " class="accordion-item bg-white mb-3">
        <div class="accordion-header mb-0" id="headingOne{{ i }}">
          <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
            data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
            attr.aria-controls="collapseOne{{ i }}" (click)="getScoreManagement(user,i)">
            <span class="me-4">
              {{ user.name ? user.name:'N/A' }}
            </span>
          </button>
        </div>
        <div id="collapse_{{ i }}" class="accordion-collapse collapse" attr.aria-labelledby="headingOne{{ i }}"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <ng-container *ngIf="ScoreManagementData?.length === 0">
              <div class="col-md-12 text-center">
                <div class="nodatafounddiv">
                  <img src=" assets/images/NoRecordFound.png" class="img-fluid" alt="" />
                  <h1 class="mt-4">
                    <app-main-heading>
                      <span title>{{
                        "MANAGEDEVICE.NODATAFOUND" | translate
                        }}</span>
                    </app-main-heading>
                  </h1>
                </div>
              </div>
            </ng-container>
            <div class="cursor-pointer" (click)="securityById(item.deviceOrSystemId)"
              *ngFor="let item of ScoreManagementData;let i = index">
              <div class="q-sm-card p-3 mt-2">
                <div class="d-flex align-items-center flex-row flex-nowrap mb-1">
                  <div class="me-2">
                    <span *ngIf="item?.deviceType == 'SYSTEM'">
                      <img src="../../../assets/images/systemRounded.svg" alt="" class="mx-auto" />
                    </span>
                    <span *ngIf="item?.deviceType == 'MOBILE'">
                      <img src="../../../assets/images/Group 1000007040scorephone.png" alt="" class="mx-auto" />
                    </span>
                  </div>
                  <div class="mb-0">
                    <div class="font-weight-700 w-20rem text-truncate">
                      {{item.name}}
                      <span class="badge badge-pill status-text-recommendation justify-content-center my-1 ms-2 "
                        *ngIf="item?.sumOfAllRecommendations!=0">
                        {{item?.sumOfAllRecommendations}} {{ "DASHBOARD.RECOMMENDATIONS"|translate}}</span>
                    </div>
                    <div class="text-xs-date font-weight-500" *ngIf="item.lastSyncDate != null">
                      {{"MANAGEDEVICE.LASTSYNCON"|translate}} {{item.lastSyncDate}}
                    </div>
                    <div class="text-xs-date font-weight-500" *ngIf="item.lastSyncDate == null">
                      {{"MANAGEDEVICE.SCORE_NOT_SYNC"|translate}}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="d-flex align-items-center">

                    <div class="font-weight-400">
                      {{"MANAGEUSER.SECURITY" | translate}} :
                    </div>
                    <div class="ms-2" style="min-width: 91px;">
                      <span class="font-weight-900"
                        [style.color]="getColor(item.securityScore)">{{item.securityScore}}</span><span
                        class="font-weight-lighter"> / {{item.securityTotalScore}}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">

                    <div class="font-weight-400 me-2">
                      {{"MANAGEUSER.PRIVACY" | translate}} :
                    </div>
                    <div class="ms-2" style="min-width: 91px;">
                      <span class="font-weight-900"
                        [style.color]="getColor(item.privacyScore)">{{item.privacyScore}}</span><span
                        class="font-weight-lighter"> / {{item.privacyTotalScore}}</span>
                    </div>
                  </div>
                </div>


                <div class="ms-5 w-auto mt-2">
                  <button class="bg-orgclr score-buttons  renew-btn  right-end mb-2"
                    (click)="securityById(item.deviceOrSystemId)">
                    {{ "MANAGEUSER.VIEWDETAILS" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal for Sync score -->
<div class="modal mx-auto fade " id="syncScoreModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog pointer-events-none modal-dialog-centered text-center">
    <div class="modal-content border-none shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
      <div class="my-4">
        <img src="../../../assets/images/refresh.svg" alt="" class="mx-auto" />
      </div>
      <h5 class="fw-bold px-4">
        {{ "SCOREMANAGEMENT.LATESTSCORE" | translate }}
      </h5>
      <div class=" my-4 d-flex justify-content-center">
        <div class="me-3">
          <button type="button" class="submit-btn bg-orgclr"
            (click)="sendCommandScore(syncScoreArr[0],syncScoreArr[1])">
            {{ "SCOREMANAGEMENT.REFRESH" | translate }}
          </button>
        </div>
        <div class="">
          <button type="button" class="cancel-btn bg-cancelbtn" (click)="closeModal()">
            {{ "LOGIN.CANCEL" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>